export default "__VITE_ASSET__CuXyqv5g__"